export const CONSENT_GOOGLE_MAPS = 's1104';
